// contexts/TextEditorDrawerContext.tsx

import React, { createContext, useContext, useState, ReactNode } from 'react';

type TextEditorDrawerContextType = {
  openManagePost: boolean;
  setOpenManagePost: (isOpen: boolean) => void;
  toggleDrawer: (inOpen: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => void;
};

const TextEditorDrawerContext = createContext<TextEditorDrawerContextType | undefined>(undefined);

export const TextEditorDrawerProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [openManagePost, setOpenManagePost] = useState<boolean>(false);

  const toggleDrawer = (inOpen: boolean) => (event?: React.KeyboardEvent | React.MouseEvent) => {
    // Only proceed with the check if the event is provided
    if (event && event.type === 'keydown' && ((event as React.KeyboardEvent).key === 'Tab' || (event as React.KeyboardEvent).key === 'Shift')) {
      return;
    }

    setOpenManagePost(inOpen);
  };

  return (
    <TextEditorDrawerContext.Provider value={{ openManagePost, setOpenManagePost, toggleDrawer }}>
      {children}
    </TextEditorDrawerContext.Provider>
  );
};

export const useTextEditorDrawer = () => {
  const context = useContext(TextEditorDrawerContext);
  if (context === undefined) {
    throw new Error('useTextEditorDrawer must be used within a TextEditorDrawerProvider');
  }
  return context;
};
